module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "untitled-1"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal-310-0-override6"
  }, [_c('span', {
    staticClass: "no-style-override21"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "heading-2-361-0-override1"
  }, [_c('span', {
    staticClass: "no-style-override27"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chapter",
    attrs: {
      "id": "toc-anchor"
    }
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "chapter1"
  }, [_vm._v("A Niggling, Worrisome Past")]), _vm._v(" "), _c('p', {
    staticClass: "firstparagraph"
  }, [_vm._v("The majesty, the spectacle, the trappings of power – all are difficult to ignore.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Admirers, and especially the true believers, continually remind you of the simple fact that the church endures. Witness the long lines at the ")]), _c('span', {
    staticClass: "no-style-override8"
  }, [_vm._v("Città del Vaticano")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v(", day after day.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("But if you take the time to study the centuries-long abuses and shockingly sordid history of the church, you’ll discover all too quickly that its zealous minions will do damn near anything to further the excesses of the faith, or at least the faith as they see it and shape it. And if Shakespeare was correct and the past truly is prologue, this legion of underlings, many thousands strong through the millennia, will go to extraordinary lengths to protect those who represent the venerable institution and toil in its vineyards, for good or for evil … not only in the past but in the present day as well. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Consider this random listing of known transgressions:")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "calibre5"
  }, [_c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Book-burnings and imprisonments and the incessant rewriting and reconstruction of history;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The mournful saga of the Crusades and the slaughter of untold hundreds of thousands of so-called non-believers;  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('ul', {
    staticClass: "calibre5"
  }, [_c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The wanton destruction of churches, synagogues, temples, and varied places of worship of those faiths deemed unworthy; ")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Witch-hunts and religious wars resulting in the deaths of shocking numbers of innocents – millions of them through the ages;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The slaughter of native peoples around the globe – from Ireland to the Hawaiian Islands and throughout the African, European, and American continents, both North and South, including what eventually became the United States;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("All-out, all-in wars against so-called heretics of all stripes and creeds across the far-flung reaches of the globe;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The historical exploitation of church indulgences, which constitutes a gut-wrenching retelling of vicious abuses and excesses;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The World War II concentration camps run by the Catholic Ustaše, which participated in the murders of people of all genders and ages, children included;")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The indifference of the Pius XII, often called Hitler’s pope, while the Nazis ran roughshod across two continents; ")])]), _vm._v(" "), _c('li', {
    staticClass: "normal-310-0-override7"
  }, [_c('span', {
    staticClass: "no-style-override-7-filtered"
  }, [_c('span', {
    staticClass: "styles-for-word-rtf-imported-lists-253-0-word-imported-list-style"
  }, [_c('span', {
    staticClass: "custom-marker-ad-hoc pcalibre"
  })])]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("The church’s involvement in the Rwanda massacres of the 1990s …")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal-310-0-override8"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("You get the idea. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("It’s a litany not of the saints but rather of grave-faced, relentless, unrepentant sinners.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("A selective recounting, you say?")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Ah, but there’s so much material to select from, with long centuries of history to cull, despite the repeated efforts of those at the helm to make it all disappear.  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Look up the sad tale of John Wycliffe, or the detailed history of the Knights Templar – never mind the myths and the accounts of revisionists or those trying to make a buck through hucksterism or movie deals or simple deceit. Take a moment to wrap your mind around the church’s dealing with Galileo Galilei, or Joan of Arc, or Jan Hus, or William Tyndale, or the true story behind the Inquisitions. These days, with a wireless connection and a ready-made internet library at your fingertips, getting to the heart of the matter is as easy as a few keystrokes and a click with a plastic mouse.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Raise these topics, of course, and the faithful, forever bleating like sheep trailing the wandering shepherd, protest vociferously that much of this recounting is culled from the distant past – the Dark Ages, which have long since been relegated to the dusty pages of a shameful if narrow slice of selective history. And while countless reports regarding the predatory practices of certain members of the clergy have come to light in shocking detail in more recent years, those missteps, too, also are just as easily dismissed by the faithful. These halo-blind followers repeatedly maintain that we should not condemn the entire institution because of the malevolent depravity of a few sick individuals … this despite the repeated attempted whitewashes from those in charge, at least some of whom have been tried and convicted for their efforts to thwart justice. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("To save you some time: ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("In 1992, exactly 350 years after Galileo’s death, Pope John Paul II apologized on behalf of the church for its denouncing of the brilliant scientist and philosopher’s lifetime of achievements and for locking him up for the final nine years of his life. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("This recent John Paul, you should know, was something of an apology machine. During his years as pope, he formally apologized not only for the Galileo debacle but also for the church’s roles in the murders of Muslims during the Crusades, for its involvement in the African slave trade, for its ongoing silence and blind eye during the Holocaust, to those who were convicted during the Inquisition, for the church’s role in the religious wars that took place after the Protestant Reformation, and for its historical treatment of Jews, women, and most everyone else who suffered at the heavy hand of the dogmatists through the centuries. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Case closed and the record set straight … right?")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Not quite. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Upon John Paul’s death in 2005, his successor, Benedict XVI, decreed that the original “verdict against Galileo was rational and just, and the revision of this verdict can be justified only on the grounds of what is politically opportune.”")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("As the wise man said, you can look it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override16"
  }, [_vm._v("I ")]), _c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("recount this slice of a sordid past not because I want to disparage the institution (I do not) but merely to point out that when something is rotten, in Denmark or in Rome, you can’t sit idly by and pretend that the cogs and the pulleys and the wheels and the wires are still in place, humming nicely along, benefiting all of mankind. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("They aren’t, I’m sad to report, and from recent first-hand experience. If you have some time, I’ll tell you about it – including the church’s tenuous connection to the shocking death of an American president more than five decades previous. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("I can’t promise an easy journey in this telling. But I will promise that it’s the truth … or at least it’s as close to the truth as I could get, given the fractious circumstances. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override7"
  }, [_vm._v("Judge for yourself.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_28"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d1daa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Prologue.vue
// module id = 84
// module chunks = 0